import React from 'react';
import { IconComponent } from '@shapeable/types'

export const DiagonalMobileSlice: IconComponent = ({ className }) => (
  <svg width="100%" height="100%" viewBox="0 0 320 58" preserveAspectRatio="none" stroke='none'
    xmlns="http://www.w3.org/2000/svg" style={{ overflow: 'hidden' }}>
    <path d="M320 0L0 58H320V0Z" fill="#3E839B"/>
  </svg>
);